'use strict';
import * as $j_app$002eapi$002e$002dGeneral$002dPractice$002dApp$002dUpdate from "./app.api.-General-Practice-App-Update.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention(ids) {
  this.Lapp_api_GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention__f_ids = null;
  this.Lapp_api_GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention__f_ids = ids;
}
export { $c_Lapp_api_GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention as $c_Lapp_api_GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention };
$c_Lapp_api_GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention.prototype = new $j_app$002eapi$002e$002dGeneral$002dPractice$002dApp$002dUpdate.$h_Lapp_api_GeneralPracticeAppUpdate();
$c_Lapp_api_GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention.prototype.constructor = $c_Lapp_api_GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention;
/** @constructor */
function $h_Lapp_api_GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention() {
}
export { $h_Lapp_api_GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention as $h_Lapp_api_GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention };
$h_Lapp_api_GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention.prototype = $c_Lapp_api_GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention.prototype;
$c_Lapp_api_GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-149292237), true);
});
$c_Lapp_api_GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_api_GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention)) {
    var x = this.Lapp_api_GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention__f_ids;
    var y = x$0.Lapp_api_GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention__f_ids;
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lapp_api_GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_api_GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention.prototype.productArity__I = (function() {
  return 1;
});
$c_Lapp_api_GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention.prototype.productPrefix__T = (function() {
  return "AcceptedDrugRequestWithoutEPSCodeNeedsAttention";
});
$c_Lapp_api_GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_api_GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention__f_ids;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_api_GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "ids";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_api_GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention.prototype.ordinal__I = (function() {
  return 6;
});
function $isArrayOf_Lapp_api_GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_api_GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention)));
}
export { $isArrayOf_Lapp_api_GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention as $isArrayOf_Lapp_api_GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention };
var $d_Lapp_api_GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention, "app.api.GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention", ({
  Lapp_api_GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention: 1,
  Lapp_api_GeneralPracticeAppUpdate: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  Lapp_api_GeneralPracticeAppUpdate$InitialState: 1
}));
export { $d_Lapp_api_GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention as $d_Lapp_api_GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention };
//# sourceMappingURL=app.api.-General-Practice-App-Update$-Accepted-Drug-Request-Without-E-P-S-Code-Needs-Attention.js.map
